import React from "react";

interface OwnProps {
}

interface OwnState {
}

export class RequiredFields extends React.Component<OwnProps, OwnState> {
    public render() {
        return <p><strong className="req">*</strong>required</p>;
    }
}



// WEBPACK FOOTER //
// ./src/components/generic/RequiredFields.tsx